import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import tabbable from 'tabbable';

var FocusTrap = _ref => {
  var {
    children,
    openFocusRef,
    closeFocusRef,
    childRef
  } = _ref;
  var beforeRef = useRef();
  var afterRef = useRef(); // Trap focus within container element

  useEffect(() => {
    var handleFocus = ev => {
      var {
        target
      } = ev;
      var tabbables = tabbable(childRef.current);

      if (target === beforeRef.current) {
        tabbables[tabbables.length - 1].focus();
      } else if (target === afterRef.current) {
        tabbables[0].focus();
      }
    };

    document.addEventListener('focusin', handleFocus);
    return () => {
      document.removeEventListener('focusin', handleFocus);
    };
  }, [childRef]); // Move focus to and from focus trap on mount/unmount

  useEffect(() => {
    var lastFocused = document.activeElement;
    var closeFocus = closeFocusRef ? closeFocusRef.current : null;

    if (openFocusRef) {
      openFocusRef.current.focus();
    } else {
      var tabbables = tabbable(childRef.current);

      if (tabbables.length) {
        tabbables[0].focus();
      }
    }

    return () => {
      if (closeFocus) {
        closeFocus.focus();
      } else {
        lastFocused.focus();
      }
    };
  }, [closeFocusRef, openFocusRef, childRef]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    tabIndex: "0",
    ref: beforeRef
  }), children, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": true,
    tabIndex: "0",
    ref: afterRef
  }));
};

FocusTrap.propTypes = {
  children: PropTypes.node,
  openFocusRef: PropTypes.shape({
    current: PropTypes.object
  }),
  closeFocusRef: PropTypes.shape({
    current: PropTypes.object
  }),
  childRef: PropTypes.shape({
    current: PropTypes.object
  }).isRequired
};
FocusTrap.defaultProps = {
  children: undefined,
  openFocusRef: undefined,
  closeFocusRef: undefined
};
export default FocusTrap;